module.exports = __webpack_public_path__ + "img/main_11.4e3ab699.jpg";